// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"486ebcc2","359":"dd9259d3","453":"aed3bee7","469":"6733eea4","618":"a4a9c62a","853":"1a6661ab","862":"8595ad5a","918":"612bb1df","968":"27916982"}[chunkId] + ".chunk.js";
};